// 账号异常提示界面 1

require("clover/panel/component/common/UIGroupButton")
require("clover/panel/base/BasePanel")

let AccountAbnormalTipPanel = xClass("AccountAbnormalTipPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})
let RES = table(
    "packed/logout.pack",
    "font/zzgftongxin_40.png",
    "font/zzgftongxin_40.fnt",
    // "packed/SeasideStarRankPanel.pack"
)
AccountAbnormalTipPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
AccountAbnormalTipPanel.preloadResPromise = function(useMask = false) {
    return preloadWithLoadingPromise(RES, useMask)
}
let _instance = null
AccountAbnormalTipPanel.getInstance = function () {
    let self = this
    return _instance
}
AccountAbnormalTipPanel.prototype.ctor = function (data) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self

    self.data = data || {}

    self.initUI();
}
AccountAbnormalTipPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}
AccountAbnormalTipPanel.prototype.onCleanup = function () {
    let self = this
    // ref 
    _instance = null
    beforeClose(self);
    ResManager.release(RES);
    // FrameLoader.unloadImageWithPlists(RES, true)
    // cc.Director.getInstance().getTextureCache().removeUnusedTextures()
}
/**
 * 关闭前的操作
 * 关闭一些动画、定时操作
 * @param {*} self 
 */
function beforeClose(self) {}


AccountAbnormalTipPanel.prototype.initUI = function () {
    let self = this
    self.mainNode = cc.CSLoader.createNode("cocos/logout_logout_feedback.csb")
    self.addChild(self.mainNode);

    this.btnClose = self.mainNode.getChildByName("close");
    this.btnClose.setVisible(false)


    self.mainNode.getChildByName("txt2").setVisible(false)
    this.btnConfirm = self.mainNode.getChildByName("button");
    quickBuildBtn(this.btnConfirm, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
        if (window.mini){
            mini.exitMiniProgram({})
        }
    }, true);

    this.btnKefu = self.mainNode.getChildByName("toast_bg").getChildByName("logout_delete")
    quickBuildBtn(this.btnKefu, UIGroupButton, PushBounceAnim, () => {
        if (this.isbusy) return
        this.isbusy = true
        function onFail() {
            Toast.make("打开社区错误，请重试！")
            this.isbusy = false
        }
        if (META.platform == XcloverPlatform.wechatgame) {
            if(mini.openCustomerServiceConversation) {
                this.isbusy = false
                mini.openCustomerServiceConversation();
            } else {
                this.isbusy = false
                Toast.make("您的App版本过低，请升级后重试");
            }
        } else {
            OpenFunscareLogic.openFunscare(1, ()=>{
                this.isbusy = false
            }, null, onFail)
        }
    }, true);
    this.btnConfirm.getChildByName("txt").setString("退出游戏")
    
    // let txtString = "亲爱的小村民，您正在进行{c=155,91,63,255/c}账号删除{c=215,42,31,255/c}操作，继续将会导致：\n1.您的{c=155,91,63,255/c}风车币，道具{c=215,42,31,255/c}等物品将会删除  {c=155,91,63,255/c}"
    // let colorLabel= getColorTextH5(txtString,16,24)
    // colorLabel.x = -colorLabel.width/2
    // // colorLabel.y = -colorLabel.height/2
    // colorLabel.y = 90

    // colorLabel.x = -110
    // let contentStr = "如果您对游戏有任何意见和建议，请点击去吐槽按钮，联系我们的工作人员，我们将竭诚为您解决问题。"
    let uid = self.data.uid || ""
    let contentStr = `当前账号（${uid}）处于封禁状态，如有疑问请联系客服。`
    let contentLable = cc.Label.createWithSystemFont(contentStr, "Arial", 30)
    contentLable.setDimensions(400, 0)
    contentLable.setColor(cc.color(155, 91, 63))
    contentLable.y = 10
    contentLable.setLineHeight(35)
    this.mainNode.addChild(contentLable)
    
    this.mainNode.getChildByName("tittle_lab").setString("帐号状态异常")
    this.mainNode.getChildByName("toast_bg").getChildByName("logout_delete").setSpriteFrame("logout/logout_service.png" )

    if (SnsProxy.getInstance().supportCustomerService() && (!window.mini || mini.getPlatform() != MiniPlatform.tt)){
        this.btnKefu.setVisible(true)
    }else{
        this.btnKefu.setVisible(false)
    }
}


AccountAbnormalTipPanel.prototype.popup = function () {
    let self = this
    let size = cc.Director.getInstance().getVisibleSize()
	self.setPosition(size.width / 2, size.height / 2)

    //popup动画
    let actionList = table()
    table.insert(actionList, cc.CallFunc.create(function () {
        self.mainNode.setScale(0.1)
    }))
    table.insert(actionList, cc.EaseSineOut.create(cc.ScaleTo.create(0.2, 1)))
    self.mainNode.runAction(cc.Sequence.create(actionList))

    var curScene = cc.Director.getInstance().getRunningScene()
	curScene.addChild(self)
	return self

}
module.exports = AccountAbnormalTipPanel